import Vue from "vue";
import VueRouter from "vue-router";
import firebase from 'firebase';

import Login from '@/components/login'
import Baustellen from '@/components/baustellen'
import Create from '@/components/create'
import Detail from '@/components/detail'
import Dashboard from '@/components/dashboard'
import Rg from '@/components/rg'
import Archiv from '@/components/archiv'
import Archivdetail from '@/components/archiv_detail'
import CreateAngebot from '@/components/create-angebot'
import Angebote from '@/components/angebote'
import EditAngebot from '@/components/edit-angebot'

Vue.use(VueRouter);

const routes = [{
    path: '*',
    redirect: '/baustellen'
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/baustellen",
    name: "Baustellen",
    component: Baustellen,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/create",
    name: "Create",
    component: Create,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: Detail,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/rg/:id/:tr",
    name: "Rg",
    component: Rg,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/archiv/",
    name: "Archiv",
    component: Archiv,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/archivdetail/:id",
    name: "Archivdetail",
    component: Archivdetail,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/angebote",
    name: "Angebote",
    component: Angebote,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/create-angebot",
    name: "CreateAngebot",
    component: CreateAngebot,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/create-angebot/:id",
    name: "PrintAngebot",
    component: CreateAngebot,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/edit-angebot/:id",
    name: "EditAngebot",
    component: EditAngebot,
    meta: {
      requiresAuth: true
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

export default router;